import script from "./Appointment.vue?vue&type=script&setup=true&lang=js"
export * from "./Appointment.vue?vue&type=script&setup=true&lang=js"

import "./Appointment.vue?vue&type=style&index=0&id=1efab61e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hairwizard/hairwizard/hwappointments/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1efab61e"]])

export default __exports__